import { message } from "antd";
import axiosInstance from "../axiosInstance";

import {
	FETCH_SURVEY_SCORES_REQUEST,
	FETCH_SURVEY_SCORES_SUCCESS,
	FETCH_SURVEY_SCORES_FAIL,
	UPDATE_SURVEY_SCORE_REQUEST,
	UPDATE_SURVEY_SCORE_SUCCESS,
	UPDATE_SURVEY_SCORE_FAIL,
	FETCH_SURVEY_SCORE_REQUEST,
	FETCH_SURVEY_SCORE_SUCCESS,
	FETCH_SURVEY_SCORE_FAIL,
} from "../constants/surveyScore";

const fetchSurveyScores = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SURVEY_SCORES_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/survey-scores", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SURVEY_SCORES_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SURVEY_SCORES_FAIL, payload: errorMessage });
	}
};

const updateSurveyScore = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_SURVEY_SCORE_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/survey-scores/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_SURVEY_SCORE_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_SURVEY_SCORE_FAIL, payload: errorMessage });
	}
};

const fetchSurveyScore = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SURVEY_SCORE_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/survey-scores/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_SURVEY_SCORE_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SURVEY_SCORE_FAIL, payload: errorMessage });
	}
};

export { fetchSurveyScores, updateSurveyScore, fetchSurveyScore };
